enum EnumTokenType {
    All = 'All',
    Point = 'Point',
    Course = 'Course',
}

export default EnumTokenType